import React from "react";
import { CheckIcon } from "lucide-react";
import { images, volumes } from "../../data/content";
import { CtaButton } from "../CtaButton";
export function Volumes() {
  return <section className="bg-white py-16 sm:py-20" aria-labelledby="volumes-title" data-id="element-286" data-mp="2x19y6o5r6ses">
      <div className="mx-auto max-w-4xl px-5" data-id="element-287" data-mp="2x34hjy1dmcgr">
        <h2 id="volumes-title" className="text-center font-display text-[30px] font-black leading-tight text-ink sm:text-[42px]" data-id="element-288" data-mp="2symzq4eku98m">
          Here's exactly what I put inside the <span className="text-brand" data-id="element-289" data-mp="2ja537zdbyoas">Safe Spine Method™</span>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-center text-[17px] leading-relaxed text-muted" data-id="element-290" data-mp="2j7sf14gzbhpa">
          I didn't want to create another ebook that you download, read once, and forget about. So I built this as a{" "}
          <strong className="text-ink" data-id="element-291" data-mp="259ubku4755ok">professional reference system</strong> — something you can study, print, revisit, and
          use when preparing your clinical workflow.
        </p>

        <ol className="relative mt-12" data-id="element-292" data-mp="335mevb37ylmm">
          {volumes.map((v, i) => <li key={v.number} className="relative flex gap-4 pb-10 last:pb-0 sm:gap-6" data-id="element-293" data-mp="334b7z2eh8xra" data-mpi={i}>
              {i < volumes.length - 1 && <span className="absolute left-[23px] top-12 h-[calc(100%-3rem)] w-0.5 bg-line sm:left-[27px]" aria-hidden="true" data-id="element-294" data-mp="2u57ss9ifl2i2" />}
              <span className="relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-navy font-display text-lg font-black text-sky sm:h-14 sm:w-14 sm:text-xl" data-id="element-295" data-mp="2y72q72x8qvqk">
                {v.number}
              </span>
              <div className="min-w-0 flex-1 pt-1" data-id="element-296" data-mp="3qsuh1k5cpekf">
                <p className="text-xs font-bold uppercase tracking-wider text-brand" data-id="element-297" data-mp="3cuns4tidqoww">Volume {v.number}</p>
                <h3 className="mt-1 font-display text-[24px] font-black leading-tight text-ink sm:text-[28px]" data-id="element-298" data-mp="3hsz357kev5gp">{v.title}</h3>
                <div className="mt-3 space-y-3 text-[16px] leading-relaxed text-muted" data-id="element-299" data-mp="21ida9i56cd78">
                  {v.body.map(p => <p key={p} data-id="element-300" data-mp="byvijo9ppjxt">{p}</p>)}
                </div>
                {v.list.length > 0 && <ul className="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-2" data-id="element-301" data-mp="6zsf289drlry">
                    {v.list.map(item => <li key={item} className="flex items-center gap-2 text-[15px] font-semibold text-ink" data-id="element-302" data-mp="27sjes0cff16">
                        <CheckIcon className="h-4 w-4 shrink-0 text-brand" strokeWidth={3} aria-hidden="true" data-id="element-303" data-mp="3ucw4booyzp11" />
                        {item}
                      </li>)}
                  </ul>}
                {v.highlight && <p className="mt-4 rounded-xl bg-brand-light px-4 py-3 text-[15px] font-semibold leading-relaxed text-navy" data-id="element-304" data-mp="3fgwx0g9opswy">
                    {v.highlight}
                  </p>}
              </div>
            </li>)}
        </ol>

        <img src={images.mockup} alt="All six volumes of the Safe Spine Method™" className="mx-auto mt-12 w-full max-w-xl" data-id="element-305" data-mp="19mx7obddl2dq" />

        <div className="mt-8" data-id="element-306" data-mp="2rlbpp82zqptw">
          <CtaButton label="I want all 6 volumes" caption="Only $27 · One-time payment" data-id="element-307" data-mp="2rk0l561q1e1q" />
        </div>
      </div>
    </section>;
}